/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import address from 'forms/shared/validators/models/location/models/address';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import { hasYesOrNo } from 'models/validate';
import { REQUIRED } from 'constants/errors';
import pvqLocationModelValidator from 'forms/shared/validators/models/location/pvqLocation';
import {
  handingProtectedInformationFrequencyOptions, handlingProtectedInformationDisciplinaryOptions, systemITTypes, systemITLocationOptions
} from 'constants/enums/informationTechnologyOptions';
import { isSafeUnitedStates } from 'helpers/locations';
import { LegalTechnologyDeniedUseItemModel } from '../types';

export const legalTechnologyDeniedItemValidator: ValidateJSModel<LegalTechnologyDeniedUseItemModel> = {
  Date: (value, attributes, attributeName, options = {}) => {
    const { applicantBirthdate } = options;
    if (isPVQForm(options?.formType)) {
      return {
        date: {
          requireDay: false, earliest: applicantBirthdate, latest: DEFAULT_LATEST
        },
      };
    }
    return {};
  },
  Incident: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.DeniedLocations?.values?.includes('Other')) {
      return { presence: true, hasValue: true };
    }
    return { };
  },
  Location: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        location: {
          validator: pvqLocationModelValidator,
          requireStreet: isSafeUnitedStates(value),
          requireIsMilitaryDiplomaticAddress: true,
          requireMilitaryDiplomaticInstallationName: true,
          requireApoFpoDpoPostcode: !isSafeUnitedStates(value),
        }
      };
    }

    return {};
  },

  Action: {}, // not used

  DeniedLocations: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        array: {
          length: { minimum: 1, message: REQUIRED },
          validator: { inclusion: systemITLocationOptions },
        }
      };
    }

    return {};
  },

  SystemName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  SystemOwner: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.SystemOwnerNotApplicable?.applicable === true) {
      return { hasValue: true };
    }
    return {};
  },
  HadSuccess: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: { validator: hasYesOrNo } };
    }
    return {};
  },
  InformationType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)
      && attributes?.HadSuccess?.value === 'Yes') {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: systemITTypes,
            },
          },
        },
      };
    }
    return {};
  },
  InformationTypeOtherExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)
      && attributes?.HadSuccess?.value === 'Yes'
      && attributes?.InformationType?.value === 'Other') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Frequency: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)
      && attributes?.HadSuccess?.value === 'Yes') {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: handingProtectedInformationFrequencyOptions,
            },
          },
        },
      };
    }
    return {};
  },
  FrequencyOtherExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)
      && attributes?.HadSuccess?.value === 'Yes'
      && attributes?.Frequency?.value === 'Other') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  IsShared: {}, // Not used
  SharedName: {}, // not used
  Occurances: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)
      && attributes?.HadSuccess?.value === 'Yes') {
      return {
        hasValue: {
          validator: {
            inclusion: {
              within: handingProtectedInformationFrequencyOptions,
            },
          },
        },
      };
    }
    return {};
  },
  OccurancesExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.HadSuccess?.value === 'Yes'
      && attributes?.Occurances?.value === 'Other') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  Reason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.HadSuccess?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },

  UnauthorizedActions: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.HadSuccess?.value === 'Yes') {
      return {
        array: {
          length: {
            message: REQUIRED,
            minimum: 1,
          },
          validator: {
            inclusion: handlingProtectedInformationDisciplinaryOptions,
            presence: true,
          }
        },
        presence: true,
      };
    }
    return {};
  },
  ActionDetails: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.HadSuccess?.value === 'Yes') {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  ActionOtherDetails: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.HadSuccess?.value === 'Yes'
      && attributes?.UnauthorizedActions?.values?.includes('Other')) {
      return { presence: true, hasValue: true };
    }
    return {};
  },

};
